/**
 * 拦截系统返回（实体返回键 / 手势返回 / history.back）。
 * 打开浮层时 push 一条同 URL 记录；返回时先交给 onSystemBack 处理，避免直接离开页面。
 * onSystemBack 返回 true：继续拦截（例如只收起键盘）；返回 false：结束拦截。
 */
export default {
  created() {
    this._onTrappedPopstate = this.onTrappedPopstate.bind(this)
  },
  beforeDestroy() {
    this.clearBackTrap()
  },
  methods: {
    startBackTrap() {
      if (this._backTrapBound) return
      this._backTrapBound = true
      history.pushState(Object.assign({}, history.state || {}, { __mwBackTrap: 1 }), '')
      window.addEventListener('popstate', this._onTrappedPopstate)
    },
    clearBackTrap() {
      if (!this._backTrapBound) return
      this._backTrapBound = false
      window.removeEventListener('popstate', this._onTrappedPopstate)
    },
    stopBackTrap() {
      if (!this._backTrapBound) return
      this._ignorePopstate = true
      this.clearBackTrap()
      history.back()
    },
    onTrappedPopstate() {
      if (this._ignorePopstate) {
        this._ignorePopstate = false
        return
      }
      const keepTrap = this.onSystemBack && this.onSystemBack()
      if (keepTrap) {
        history.pushState(Object.assign({}, history.state || {}, { __mwBackTrap: 1 }), '')
      } else {
        this.clearBackTrap()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/interceptSystemBack.js